// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import {
  DeleteDataWrapper,
  PatchDataWrapper,
  PostDataWrapper,
  QueryWrapperNext,
} from '@diamond/shared/data-access';
import { User, UserDetail } from '@diamond/shared/types';
import { useState } from 'react';

import { useAuthStore } from '../stores';

interface UserShipto {
  data: {
    id: string;
    name: string;
  }[];
  pagination: { pages: number; rows: number };
}

interface UseUserManagementDataProps {
  size: number;
  page: number;
}
export function useUserManagementData(
  queryString?: UseUserManagementDataProps
) {
  const session = useAuthStore();
  const userURL = '/user/buyer';
  const userShiptoURL = '/user/shipto';
  const changeToAdminURL = '/user/request/change-to-admin';
  const query = QueryWrapperNext(userURL, session.access_token);
  const queryShipto = QueryWrapperNext(userShiptoURL, session.access_token);
  const [userId, setUserId] = useState<string>('');
  const [status, setStatus] = useState<string>('active');
  const [shiptoSize, setShiptoSize] = useState<number>(25);
  const shiptoDefaultValue = {
    data: [],
    pagination: { pages: 0, rows: 0 },
  };

  const {
    data,
    refetch,
    isLoading: isLoadingUser,
    pageCount,
  } = query.useQueryData<User>('All Users', {
    status: status,
    size: queryString ? queryString.size : 25,
    page: queryString ? queryString.page : 1,
  });

  const { data: shipto, isLoading: isLoadingUserShipTo } =
    queryShipto.useQueryGetAll<UserShipto>('Shipto', {
      status: status,
      size: shiptoSize,
    });

  const {
    data: userDetail,
    refetch: refetchUserDetail,
    isLoading: isLoadingUserDetail,
  } = query.useQueryGetById<UserDetail>(userId, 'UserBillToData');

  const { postData: postUser } = PostDataWrapper(
    userURL,
    session.access_token,
    false,
    'buyer'
  );
  const { deleteData } = DeleteDataWrapper(userURL, session.access_token);
  const { patchData: patchUser } = PatchDataWrapper(
    userURL,
    session.access_token,
    'buyer'
  );
  const { patchData: patchToAdmin } = PatchDataWrapper(
    changeToAdminURL,
    session.access_token,
    'buyer'
  );

  const shiptoData = shipto ? shipto : shiptoDefaultValue;
  return {
    data,
    shiptoData,
    setShiptoSize,
    userDetail,
    status,
    userId,
    setUserId,
    setStatus,
    postUser,
    patchUser,
    patchToAdmin,
    deleteData,
    refetch,
    refetchUserDetail,
    pageCount,
    isLoadingUser,
    isLoadingUserShipTo,
    isLoadingUserDetail,
  };
}

export default useUserManagementData;
